<!-- 图片链接 -->
<template>
<div class='cm_img_link_container'>
  <img :src="item.path"  @click="toUrl(item.url)" v-for="item in imgData" :key="item.id">
</div>  
</template>

<script>

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
props:["data"],
data() {
//这里存放数据
return {
  imgData:this.data.img
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  toUrl(url){
    if(/^http[s]?:\/\/.*/.test(url)){
      window.open(url)
    }else{
      const newUrl = this.$router.resolve({path: url})
      window.open(newUrl.href,'_blank')
    }
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
.cm_img_link_container{
    width: 390px;
    height: 308px;
    background: rgba(255, 255, 255, 1);
    overflow: hidden;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    flex-direction: column;
}
.cm_img_link_container>:first-child{
  margin: 0;;
}
.cm_img_link_container>img{
  width: 100%;
  margin-top: 10px;
  height: 10px;
  flex: 1;
  cursor: pointer;
}
</style>